import { HTMLProps, useEffect } from "react";

import Placeholder from "@tiptap/extension-placeholder";
import { Editor, EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

import { TemplateExtension } from "@/components/pieces/editor/tiptap/TemplateExtension";

interface ExpandableTextInputProps
  extends Omit<HTMLProps<HTMLDivElement>, "onChange"> {
  value: string;
  onChange: (value: string) => void;
  onEditorChange?: (editor: Editor | null) => void;
  editorRef?: React.RefObject<Editor | null>;
  templateId?: string | null;
  className?: string;
  mode?: "html" | "text";
}

function ExpandableTextInput({
  value,
  onChange,
  onEditorChange,
  templateId,
  className,
  mode = "html",
  ...props
}: ExpandableTextInputProps) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({ placeholder: props.placeholder }),
      TemplateExtension.configure({ templateId }),
    ],
    content: value,
    onUpdate: ({ editor }) => {
      onChange(mode === "html" ? editor.getHTML() : editor.getText());
    },
    editorProps: {
      attributes: {
        class: "focus:outline-none",
      },
    },
  });

  useEffect(() => {
    if (onEditorChange) {
      onEditorChange(editor);
    }
  }, [editor]);

  return (
    <EditorContent
      editor={editor}
      className={`w-full [&_ol]:list-[revert] [&_ol]:pl-6 [&_ul]:list-[revert] [&_ul]:pl-6 ${className}`}
      {...props}
    />
  );
}

export { ExpandableTextInput };
